import React from 'react';

import { COLORS } from '@constants/colors';

interface SliderProps {
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
  step?: number;
  minLabel?: string;
  maxLabel?: string;
  className?: string;
  disabled?: boolean;
}

const Slider: React.FC<SliderProps> = ({
  value,
  onChange,
  min,
  max,
  step = 1,
  minLabel,
  maxLabel,
  className = '',
  disabled = false,
}) => {
  return (
    <div className={className}>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          .slider {
            background: #e5e7eb;
            outline: none;
          }

          .slider:focus {
            outline: none;
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
          }

          .slider::-webkit-slider-thumb {
            appearance: none;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: ${COLORS.accent};
            cursor: pointer;
            border: 3px solid white;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
            transition: all 0.2s ease;
            outline: none;
          }

          .slider::-webkit-slider-thumb:hover {
            transform: scale(1.1);
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
          }

          .slider::-webkit-slider-thumb:focus {
            outline: none;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2), 0 0 0 3px rgba(59, 130, 246, 0.2);
          }

          .slider::-moz-range-thumb {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: ${COLORS.accent};
            cursor: pointer;
            border: 3px solid white;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
            transition: all 0.2s ease;
            outline: none;
          }

          .slider::-moz-range-thumb:hover {
            transform: scale(1.1);
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
          }

          .slider::-moz-range-thumb:focus {
            outline: none;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2), 0 0 0 3px rgba(59, 130, 246, 0.2);
          }
        `,
        }}
      />

      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={disabled ? undefined : e => onChange(Number(e.target.value))}
        className={`w-full mt-4 h-2 rounded-lg appearance-none bg-gray-200 slider ${
          disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
        }`}
        style={{
          background: disabled
            ? '#e5e7eb'
            : `linear-gradient(to right, ${COLORS.accent} 0%, ${COLORS.accent} ${((value - min) / (max - min)) * 100}%, #e5e7eb ${((value - min) / (max - min)) * 100}%, #e5e7eb 100%)`,
        }}
        disabled={disabled}
      />

      {(minLabel || maxLabel) && (
        <div className="flex justify-between text-xs text-gray-500 mt-2">
          <span>{minLabel || min}</span>
          <span>{maxLabel || max}</span>
        </div>
      )}
    </div>
  );
};

export default Slider;
